// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"style_mainSection__NwGG2","animation":"style_animation__rLeAW"};